import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as ee, createElementVNode as r, createStaticVNode as i, normalizeClass as te, openBlock as a } from "vue";
//#region ../src/icons/webex.vue
var o = {
	name: "DtIconWebex",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], c = ["fill"], l = ["fill"], u = ["fill"], d = ["fill"], f = ["fill"], p = ["fill"], m = ["fill"], h = ["fill"], g = ["fill"], _ = ["fill"], v = ["fill"], y = ["fill"], b = ["fill"], x = ["fill"], S = ["fill"], C = ["fill"], w = ["fill"], T = ["fill"], E = ["fill"], D = ["fill"], O = ["fill"], k = ["fill"], A = ["fill"], j = ["fill"], M = ["fill"], N = ["fill"], P = ["fill"], F = ["fill"], I = ["fill"], L = ["fill"], R = ["fill"], z = ["fill"], B = ["fill"], V = ["fill"], H = ["fill"], U = ["id"], W = ["id"], ne = ["id"], G = ["id"], K = ["id"], q = ["id"], J = ["id"], Y = ["id"], X = ["id"], Z = ["id"], re = ["id"], ie = ["id"], ae = ["id"], oe = ["id"], se = ["id"], ce = ["id"], le = ["id"], ue = ["id"], de = ["id"], fe = ["id"], pe = ["id"], me = ["id"], he = ["id"], ge = ["id"], _e = ["id"], ve = ["id"], ye = ["id"], be = ["id"], xe = ["id"], Q = ["id"], Se = ["id"], Ce = ["id"], we = ["id"], Te = ["id"], Ee = ["id"];
function De(e, t, n, o, De, $) {
	return a(), ee("svg", {
		"aria-label": n.ariaLabel,
		class: te([$.iconSizeClass, "d-icon d-icon--webex"]),
		"data-qa": $.dataQA,
		"aria-hidden": $.ariaHidden,
		role: "img",
		"data-name": "Webex",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, c),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, l),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}c)`
		}, null, 8, u),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}d)`
		}, null, 8, d),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}e)`
		}, null, 8, f),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}f)`
		}, null, 8, p),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}g)`
		}, null, 8, m),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}h)`
		}, null, 8, h),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}i)`
		}, null, 8, g),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}j)`
		}, null, 8, _),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}k)`
		}, null, 8, v),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}l)`
		}, null, 8, y),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}m)`
		}, null, 8, b),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}n)`
		}, null, 8, x),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}o)`
		}, null, 8, S),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}p)`
		}, null, 8, C),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}q)`
		}, null, 8, w),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}r)`
		}, null, 8, T),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}s)`
		}, null, 8, E),
		r("path", {
			d: "M6.214 12.157c.977 3.254 2.393 5.271 3.487.616-.105-.015 2.224-6.176 2.322-6.414.898-1.195 2.344-1.931 3.846-1.917 2.965-.229 6.043 3.885 5.236 5.876-.552 1.44-2.624 1.747-3.577.538-.332-.412-.464-.934-.751-1.39-.555-1.033-1.288-1.136-1.76.022-.395.862-.607 1.758-.819 2.667l-.897 2.916-1.256 2.77a4.872 4.872 0 0 1-3.801 1.882c-5.89-.29-6.402-8.141-6.875-10.504-.066-.651-.003-.958.27-1.47.723-1.274 2.722-1.344 3.544-.134.292.403.347.92.403 1.402.123 1.054.336 2.107.628 3.14Z",
			fill: `url(#${e.uniqueID}t)`
		}, null, 8, D),
		r("path", {
			d: "m10.642 10.016 1.379-3.667c1.525-2.114 4.788-2.57 6.807-.898 1.412 1.065 2.254 3.174 2.254 3.174.358.77.176 1.776-.437 2.366-.84.873-2.36.795-3.117-.145-.502-.556-.941-2.637-1.984-2.12-.78.772-.95 1.976-1.245 2.984-.003.195-.92 3.077-.998 3.352l-2.657-5.045-.002-.001Z",
			fill: `url(#${e.uniqueID}u)`
		}, null, 8, O),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.099 1.68 1.123 2.68.053 1.578-1.783 2.66-3.12 1.816-.474 2.005-2.003 6.357-3.25 2.984-.608-1.796-.8-3.042-1.29-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.525 1.264 1.581 2.209.062 1.059.326 2.085.617 3.106 1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}v)`
		}, null, 8, k),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}w)`
		}, null, 8, A),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}x)`
		}, null, 8, j),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}y)`
		}, null, 8, M),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}z)`
		}, null, 8, N),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}A)`
		}, null, 8, P),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}B)`
		}, null, 8, F),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}C)`
		}, null, 8, I),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}D)`
		}, null, 8, L),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}E)`
		}, null, 8, R),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}F)`
		}, null, 8, z),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}G)`
		}, null, 8, B),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.153 1.68 1.178 2.68.052 1.578-1.838 2.66-3.174 1.816-.475 2.005-2.004 6.357-3.252 2.984-.607-1.796-.8-3.042-1.289-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}H)`
		}, null, 8, V),
		r("path", {
			d: "M20.61 6.752c-.178 0-.359.022-.526.068.506.83 1.099 1.68 1.123 2.68.053 1.578-1.783 2.66-3.12 1.816-.474 2.005-2.003 6.357-3.25 2.984-.608-1.796-.8-3.042-1.29-4.71-1.37-5.86-6.926-6.632-9.542-2.77 1.02.237 1.563 1.216 1.581 2.209a19.47 19.47 0 0 0 .617 3.106c1.686-5.18 2.684-3.857 3.476-.628.763 3.262 1.634 6.646 3.812 7.636 2.868 1.541 6.014-.056 7.22-2.793.926-1.824 1.475-3.794 1.794-5.808.094-.804.352-1.654.08-2.445a2.154 2.154 0 0 0-1.975-1.345Z",
			fill: `url(#${e.uniqueID}I)`
		}, null, 8, H),
		r("defs", null, [
			r("radialGradient", {
				id: `${e.uniqueID}b`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(2.13439 7.60352 -5.7791 1.62226 13.31 10.864)"
			}, [...t[0] || (t[0] = [
				r("stop", { "stop-color": "#227B60" }, null, -1),
				r("stop", {
					offset: ".14",
					"stop-color": "#227B60",
					"stop-opacity": ".81"
				}, null, -1),
				r("stop", {
					offset: ".58",
					"stop-color": "#227B60",
					"stop-opacity": ".23"
				}, null, -1),
				r("stop", {
					offset: ".78",
					"stop-color": "#227B60",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, U),
			r("radialGradient", {
				id: `${e.uniqueID}c`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(91.15 2.372 12.498) scale(5.34037 4.0585)"
			}, [...t[1] || (t[1] = [
				r("stop", { "stop-color": "#227B60" }, null, -1),
				r("stop", {
					offset: ".25",
					"stop-color": "#227B60",
					"stop-opacity": ".7"
				}, null, -1),
				r("stop", {
					offset: ".71",
					"stop-color": "#227B60",
					"stop-opacity": ".2"
				}, null, -1),
				r("stop", {
					offset: ".92",
					"stop-color": "#227B60",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, W),
			r("radialGradient", {
				id: `${e.uniqueID}d`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(.12163 4.97661 -3.53355 .08636 14.406 10.475)"
			}, [...t[2] || (t[2] = [i("<stop stop-color=\"#227B60\"></stop><stop offset=\".07\" stop-color=\"#227B60\" stop-opacity=\".9\"></stop><stop offset=\".34\" stop-color=\"#227B60\" stop-opacity=\".51\"></stop><stop offset=\".59\" stop-color=\"#227B60\" stop-opacity=\".23\"></stop><stop offset=\".79\" stop-color=\"#227B60\" stop-opacity=\".06\"></stop><stop offset=\".92\" stop-color=\"#227B60\" stop-opacity=\"0\"></stop>", 6)])], 8, ne),
			r("radialGradient", {
				id: `${e.uniqueID}e`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(88.6 2.116 12.62) scale(4.01949 2.85355)"
			}, [...t[3] || (t[3] = [
				r("stop", { "stop-color": "#227B60" }, null, -1),
				r("stop", {
					offset: ".36",
					"stop-color": "#227B60",
					"stop-opacity": ".63"
				}, null, -1),
				r("stop", {
					offset: ".92",
					"stop-color": "#227B60",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, G),
			r("radialGradient", {
				id: `${e.uniqueID}f`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(.07832 3.20482 -2.05149 .05014 14.505 10.46)"
			}, [...t[4] || (t[4] = [i("<stop stop-color=\"#20735A\"></stop><stop offset=\".15\" stop-color=\"#20745A\" stop-opacity=\".93\"></stop><stop offset=\".38\" stop-color=\"#21755C\" stop-opacity=\".74\"></stop><stop offset=\".67\" stop-color=\"#21785D\" stop-opacity=\".43\"></stop><stop offset=\"1\" stop-color=\"#227B60\" stop-opacity=\"0\"></stop>", 5)])], 8, K),
			r("radialGradient", {
				id: `${e.uniqueID}g`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(4.71998 2.08176 -1.56132 3.53999 15.107 10.823)"
			}, [...t[5] || (t[5] = [
				r("stop", { "stop-color": "#227A61" }, null, -1),
				r("stop", {
					offset: ".36",
					"stop-color": "#227A61",
					"stop-opacity": ".56"
				}, null, -1),
				r("stop", {
					offset: ".72",
					"stop-color": "#227A61",
					"stop-opacity": ".16"
				}, null, -1),
				r("stop", {
					offset: ".9",
					"stop-color": "#227A61",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, q),
			r("radialGradient", {
				id: `${e.uniqueID}h`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(35.27 1.871 22.367) scale(6.87972 6.29006)"
			}, [...t[6] || (t[6] = [i("<stop stop-color=\"#3CD9C3\"></stop><stop offset=\".07\" stop-color=\"#3BD7C1\" stop-opacity=\".9\"></stop><stop offset=\".41\" stop-color=\"#38CEB9\" stop-opacity=\".42\"></stop><stop offset=\".65\" stop-color=\"#36C8B4\" stop-opacity=\".12\"></stop><stop offset=\".76\" stop-color=\"#35C6B2\" stop-opacity=\"0\"></stop>", 5)])], 8, J),
			r("radialGradient", {
				id: `${e.uniqueID}i`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(35.27 3992.42 -16350.874) scale(1222.04 857.335)"
			}, [...t[7] || (t[7] = [i("<stop stop-color=\"#3CD9C3\"></stop><stop offset=\".07\" stop-color=\"#3BD7C1\" stop-opacity=\".9\"></stop><stop offset=\".41\" stop-color=\"#38CEB9\" stop-opacity=\".42\"></stop><stop offset=\".65\" stop-color=\"#36C8B4\" stop-opacity=\".12\"></stop><stop offset=\".76\" stop-color=\"#35C6B2\" stop-opacity=\"0\"></stop>", 5)])], 8, Y),
			r("radialGradient", {
				id: `${e.uniqueID}j`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(-1.15454 5.95627 -7.36134 -1.4269 15.633 12.59)"
			}, [...t[8] || (t[8] = [i("<stop stop-color=\"#237F66\" stop-opacity=\".8\"></stop><stop offset=\".06\" stop-color=\"#2C8C70\" stop-opacity=\".65\"></stop><stop offset=\".21\" stop-color=\"#3DA785\" stop-opacity=\".37\"></stop><stop offset=\".35\" stop-color=\"#4ABA93\" stop-opacity=\".17\"></stop><stop offset=\".47\" stop-color=\"#51C59C\" stop-opacity=\".04\"></stop><stop offset=\".56\" stop-color=\"#54C99F\" stop-opacity=\"0\"></stop>", 6)])], 8, X),
			r("radialGradient", {
				id: `${e.uniqueID}k`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(5.00898 -6.14599 6.63764 5.40967 12.659 12.66)"
			}, [...t[9] || (t[9] = [i("<stop stop-color=\"#167C8A\"></stop><stop offset=\".04\" stop-color=\"#167C8A\" stop-opacity=\".93\"></stop><stop offset=\".33\" stop-color=\"#177F8D\" stop-opacity=\".43\"></stop><stop offset=\".54\" stop-color=\"#17818F\" stop-opacity=\".12\"></stop><stop offset=\".65\" stop-color=\"#178290\" stop-opacity=\"0\"></stop>", 5)])], 8, Z),
			r("radialGradient", {
				id: `${e.uniqueID}l`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(-31.66 29.596 -14.578) scale(7.83644 6.19101)"
			}, [...t[10] || (t[10] = [i("<stop offset=\".05\" stop-color=\"#177D87\"></stop><stop offset=\".11\" stop-color=\"#177E89\" stop-opacity=\".8\"></stop><stop offset=\".21\" stop-color=\"#177F8B\" stop-opacity=\".52\"></stop><stop offset=\".32\" stop-color=\"#17818D\" stop-opacity=\".29\"></stop><stop offset=\".42\" stop-color=\"#17818F\" stop-opacity=\".13\"></stop><stop offset=\".51\" stop-color=\"#178290\" stop-opacity=\".03\"></stop><stop offset=\".6\" stop-color=\"#178290\" stop-opacity=\"0\"></stop>", 7)])], 8, re),
			r("radialGradient", {
				id: `${e.uniqueID}m`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(-130.54 8.123 4.305) scale(4.60803 3.62824)"
			}, [...t[11] || (t[11] = [i("<stop offset=\".26\" stop-color=\"#177F8A\"></stop><stop offset=\".27\" stop-color=\"#177F8A\" stop-opacity=\".98\"></stop><stop offset=\".38\" stop-color=\"#17808C\" stop-opacity=\".68\"></stop><stop offset=\".5\" stop-color=\"#17818D\" stop-opacity=\".43\"></stop><stop offset=\".62\" stop-color=\"#17818F\" stop-opacity=\".24\"></stop><stop offset=\".74\" stop-color=\"#17828F\" stop-opacity=\".11\"></stop><stop offset=\".86\" stop-color=\"#178290\" stop-opacity=\".03\"></stop><stop offset=\"1\" stop-color=\"#178290\" stop-opacity=\"0\"></stop>", 8)])], 8, ie),
			r("radialGradient", {
				id: `${e.uniqueID}n`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(-173.11 5.113 7.166) scale(4.32268)"
			}, [...t[12] || (t[12] = [i("<stop stop-color=\"#13656E\"></stop><stop offset=\".11\" stop-color=\"#13646E\" stop-opacity=\".73\"></stop><stop offset=\".27\" stop-color=\"#12646E\" stop-opacity=\".41\"></stop><stop offset=\".42\" stop-color=\"#12636E\" stop-opacity=\".18\"></stop><stop offset=\".55\" stop-color=\"#12636E\" stop-opacity=\".05\"></stop><stop offset=\".66\" stop-color=\"#12636E\" stop-opacity=\"0\"></stop>", 6)])], 8, ae),
			r("radialGradient", {
				id: `${e.uniqueID}o`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(-1.49979 -2.6704 2.24306 -1.25978 9.292 15.322)"
			}, [...t[13] || (t[13] = [i("<stop offset=\".13\" stop-color=\"#146A73\"></stop><stop offset=\".24\" stop-color=\"#156F79\" stop-opacity=\".79\"></stop><stop offset=\".45\" stop-color=\"#167783\" stop-opacity=\".45\"></stop><stop offset=\".65\" stop-color=\"#167D8A\" stop-opacity=\".2\"></stop><stop offset=\".82\" stop-color=\"#17818E\" stop-opacity=\".05\"></stop><stop offset=\".95\" stop-color=\"#178290\" stop-opacity=\"0\"></stop>", 6)])], 8, oe),
			r("radialGradient", {
				id: `${e.uniqueID}p`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.59048 -2.3571 1.86739 1.26004 8.97 13.84)"
			}, [...t[14] || (t[14] = [i("<stop stop-color=\"#198E9C\"></stop><stop offset=\".1\" stop-color=\"#198E9C\" stop-opacity=\".87\"></stop><stop offset=\".41\" stop-color=\"#198E9C\" stop-opacity=\".5\"></stop><stop offset=\".67\" stop-color=\"#198E9C\" stop-opacity=\".23\"></stop><stop offset=\".88\" stop-color=\"#198E9C\" stop-opacity=\".06\"></stop><stop offset=\"1\" stop-color=\"#198E9C\" stop-opacity=\"0\"></stop>", 6)])], 8, se),
			r("radialGradient", {
				id: `${e.uniqueID}w`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(98.69 3.769 13.248) scale(9.50365 6.27223)"
			}, [...t[15] || (t[15] = [
				r("stop", { "stop-color": "#1A3D9C" }, null, -1),
				r("stop", {
					offset: ".4",
					"stop-color": "#1A3D9C",
					"stop-opacity": ".42"
				}, null, -1),
				r("stop", {
					offset: ".7",
					"stop-color": "#1A3D9C",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, ce),
			r("radialGradient", {
				id: `${e.uniqueID}x`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(98.69 3564.115 -4205.073) scale(1169.36 630.292)"
			}, [...t[16] || (t[16] = [
				r("stop", { "stop-color": "#1A3D9C" }, null, -1),
				r("stop", {
					offset: ".4",
					"stop-color": "#1A3D9C",
					"stop-opacity": ".42"
				}, null, -1),
				r("stop", {
					offset: ".7",
					"stop-color": "#1A3D9C",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, le),
			r("radialGradient", {
				id: `${e.uniqueID}y`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(-208.73104 1376.9188 -568.63835 -86.2015 449.639 -8432.51)"
			}, [...t[17] || (t[17] = [
				r("stop", { "stop-color": "#1A3D9C" }, null, -1),
				r("stop", {
					offset: ".4",
					"stop-color": "#1A3D9C",
					"stop-opacity": ".42"
				}, null, -1),
				r("stop", {
					offset: ".7",
					"stop-color": "#1A3D9C",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, ue),
			r("radialGradient", {
				id: `${e.uniqueID}z`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(83.09 1.625 15.09) scale(8.3065 5.79627)"
			}, [...t[18] || (t[18] = [i("<stop stop-color=\"#1A3D9C\"></stop><stop offset=\".16\" stop-color=\"#1A3D9C\" stop-opacity=\".69\"></stop><stop offset=\".33\" stop-color=\"#1A3D9C\" stop-opacity=\".4\"></stop><stop offset=\".49\" stop-color=\"#1A3D9C\" stop-opacity=\".18\"></stop><stop offset=\".61\" stop-color=\"#1A3D9C\" stop-opacity=\".05\"></stop><stop offset=\".7\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 6)])], 8, de),
			r("radialGradient", {
				id: `${e.uniqueID}A`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(2.11462 7.69808 -5.23453 1.4379 17.747 12.507)"
			}, [...t[19] || (t[19] = [
				r("stop", { "stop-color": "#18388F" }, null, -1),
				r("stop", {
					offset: ".37",
					"stop-color": "#193B96",
					"stop-opacity": ".45"
				}, null, -1),
				r("stop", {
					offset: ".7",
					"stop-color": "#1A3D9C",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, fe),
			r("radialGradient", {
				id: `${e.uniqueID}B`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(74.64 -1 18.508) scale(3.71184 3.52569)"
			}, [...t[20] || (t[20] = [i("<stop stop-color=\"#18388F\"></stop><stop offset=\".09\" stop-color=\"#183992\" stop-opacity=\".78\"></stop><stop offset=\".22\" stop-color=\"#193B96\" stop-opacity=\".5\"></stop><stop offset=\".35\" stop-color=\"#193C98\" stop-opacity=\".28\"></stop><stop offset=\".47\" stop-color=\"#1A3C9A\" stop-opacity=\".13\"></stop><stop offset=\".59\" stop-color=\"#1A3D9C\" stop-opacity=\".03\"></stop><stop offset=\".7\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 7)])], 8, pe),
			r("radialGradient", {
				id: `${e.uniqueID}C`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(74.64 -1.39 18.874) scale(3.71184 3.52569)"
			}, [...t[21] || (t[21] = [i("<stop stop-color=\"#1A3D9C\" stop-opacity=\".78\"></stop><stop offset=\".24\" stop-color=\"#1A3D9C\" stop-opacity=\".45\"></stop><stop offset=\".44\" stop-color=\"#1A3D9C\" stop-opacity=\".2\"></stop><stop offset=\".6\" stop-color=\"#1A3D9C\" stop-opacity=\".05\"></stop><stop offset=\".7\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 5)])], 8, me),
			r("radialGradient", {
				id: `${e.uniqueID}D`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(67.03 -5.966 12.195) scale(8.85826 5.87875)"
			}, [...t[22] || (t[22] = [i("<stop stop-color=\"#1A3D9C\"></stop><stop offset=\".4\" stop-color=\"#1A3D9C\" stop-opacity=\".56\"></stop><stop offset=\".48\" stop-color=\"#1A3D9C\" stop-opacity=\".43\"></stop><stop offset=\".69\" stop-color=\"#1A3D9C\" stop-opacity=\".12\"></stop><stop offset=\".79\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 5)])], 8, he),
			r("radialGradient", {
				id: `${e.uniqueID}E`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(76.1 -3.631 9.511) scale(6.57096 4.33828)"
			}, [...t[23] || (t[23] = [i("<stop stop-color=\"#1A3D9C\"></stop><stop offset=\".06\" stop-color=\"#1A3D9C\" stop-opacity=\".88\"></stop><stop offset=\".21\" stop-color=\"#1A3D9C\" stop-opacity=\".61\"></stop><stop offset=\".36\" stop-color=\"#1A3D9C\" stop-opacity=\".39\"></stop><stop offset=\".51\" stop-color=\"#1A3D9C\" stop-opacity=\".22\"></stop><stop offset=\".67\" stop-color=\"#1A3D9C\" stop-opacity=\".1\"></stop><stop offset=\".83\" stop-color=\"#1A3D9C\" stop-opacity=\".02\"></stop><stop offset=\"1\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 8)])], 8, ge),
			r("radialGradient", {
				id: `${e.uniqueID}F`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(76.1 -3.631 9.511) scale(6.57096 4.33828)"
			}, [...t[24] || (t[24] = [i("<stop stop-color=\"#1B3E9E\"></stop><stop offset=\".06\" stop-color=\"#1B3E9E\" stop-opacity=\".87\"></stop><stop offset=\".21\" stop-color=\"#1B3E9D\" stop-opacity=\".61\"></stop><stop offset=\".36\" stop-color=\"#1A3D9D\" stop-opacity=\".39\"></stop><stop offset=\".52\" stop-color=\"#1A3D9C\" stop-opacity=\".22\"></stop><stop offset=\".67\" stop-color=\"#1A3D9C\" stop-opacity=\".1\"></stop><stop offset=\".83\" stop-color=\"#1A3D9C\" stop-opacity=\".02\"></stop><stop offset=\"1\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 8)])], 8, _e),
			r("radialGradient", {
				id: `${e.uniqueID}G`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(1.20766 4.87994 -3.22119 .79716 7.038 10.013)"
			}, [...t[25] || (t[25] = [i("<stop stop-color=\"#183991\"></stop><stop offset=\".03\" stop-color=\"#183992\" stop-opacity=\".95\"></stop><stop offset=\".18\" stop-color=\"#193A95\" stop-opacity=\".66\"></stop><stop offset=\".34\" stop-color=\"#193B97\" stop-opacity=\".42\"></stop><stop offset=\".5\" stop-color=\"#1A3C99\" stop-opacity=\".24\"></stop><stop offset=\".66\" stop-color=\"#1A3D9B\" stop-opacity=\".1\"></stop><stop offset=\".82\" stop-color=\"#1A3D9C\" stop-opacity=\".03\"></stop><stop offset=\"1\" stop-color=\"#1A3D9C\" stop-opacity=\"0\"></stop>", 8)])], 8, ve),
			r("radialGradient", {
				id: `${e.uniqueID}H`,
				cx: "0",
				cy: "0",
				r: "1",
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(.19816 3.96661 -3.49235 .17447 8.602 11.48)"
			}, [...t[26] || (t[26] = [
				r("stop", {
					offset: ".04",
					"stop-color": "#2453D6",
					"stop-opacity": ".6"
				}, null, -1),
				r("stop", {
					offset: ".2",
					"stop-color": "#2453D6",
					"stop-opacity": ".49"
				}, null, -1),
				r("stop", {
					offset: ".52",
					"stop-color": "#2453D6",
					"stop-opacity": ".2"
				}, null, -1),
				r("stop", {
					offset: ".73",
					"stop-color": "#2453D6",
					"stop-opacity": "0"
				}, null, -1)
			])], 8, ye),
			r("linearGradient", {
				id: `${e.uniqueID}a`,
				x1: "2.239",
				y1: "14.79",
				x2: "18.928",
				y2: "8.043",
				gradientUnits: "userSpaceOnUse"
			}, [...t[27] || (t[27] = [i("<stop offset=\".13\" stop-color=\"#1CBBF3\"></stop><stop offset=\".34\" stop-color=\"#1F99A5\"></stop><stop offset=\".45\" stop-color=\"#209CA6\"></stop><stop offset=\".51\" stop-color=\"#24A4AA\"></stop><stop offset=\".57\" stop-color=\"#2BB3B0\"></stop><stop offset=\".6\" stop-color=\"#30BDB4\"></stop><stop offset=\".79\" stop-color=\"#38BA90\"></stop><stop offset=\"1\" stop-color=\"#60F05A\"></stop>", 8)])], 8, be),
			r("linearGradient", {
				id: `${e.uniqueID}q`,
				x1: "3.364",
				y1: "4.084",
				x2: "10.702",
				y2: "10.875",
				gradientUnits: "userSpaceOnUse"
			}, [...t[28] || (t[28] = [i("<stop offset=\".13\" stop-color=\"#2BF9FF\"></stop><stop offset=\".27\" stop-color=\"#29F9FF\" stop-opacity=\".64\"></stop><stop offset=\".4\" stop-color=\"#27FAFF\" stop-opacity=\".3\"></stop><stop offset=\".49\" stop-color=\"#26FAFF\" stop-opacity=\".08\"></stop><stop offset=\".54\" stop-color=\"#26FAFF\" stop-opacity=\"0\"></stop>", 5)])], 8, xe),
			r("linearGradient", {
				id: `${e.uniqueID}r`,
				x1: "-.806",
				y1: "15.169",
				x2: "7.761",
				y2: "12.739",
				gradientUnits: "userSpaceOnUse"
			}, [...t[29] || (t[29] = [i("<stop stop-color=\"#26FAFF\"></stop><stop offset=\".06\" stop-color=\"#26FAFF\" stop-opacity=\".88\"></stop><stop offset=\".24\" stop-color=\"#26FAFF\" stop-opacity=\".51\"></stop><stop offset=\".39\" stop-color=\"#26FAFF\" stop-opacity=\".23\"></stop><stop offset=\".5\" stop-color=\"#26FAFF\" stop-opacity=\".06\"></stop><stop offset=\".55\" stop-color=\"#26FAFF\" stop-opacity=\"0\"></stop>", 6)])], 8, Q),
			r("linearGradient", {
				id: `${e.uniqueID}s`,
				x1: "1.434",
				y1: "14.882",
				x2: "11.114",
				y2: "11.432",
				gradientUnits: "userSpaceOnUse"
			}, [...t[30] || (t[30] = [i("<stop stop-color=\"#21DEFF\"></stop><stop offset=\".04\" stop-color=\"#21DEFF\" stop-opacity=\".88\"></stop><stop offset=\".17\" stop-color=\"#21DEFF\" stop-opacity=\".51\"></stop><stop offset=\".27\" stop-color=\"#21DEFF\" stop-opacity=\".23\"></stop><stop offset=\".34\" stop-color=\"#21DEFF\" stop-opacity=\".06\"></stop><stop offset=\".38\" stop-color=\"#21DEFF\" stop-opacity=\"0\"></stop>", 6)])], 8, Se),
			r("linearGradient", {
				id: `${e.uniqueID}t`,
				x1: "10.664",
				y1: "9.876",
				x2: "16.065",
				y2: "18.686",
				gradientUnits: "userSpaceOnUse"
			}, [...t[31] || (t[31] = [i("<stop offset=\".62\" stop-color=\"#21DEFF\" stop-opacity=\"0\"></stop><stop offset=\".66\" stop-color=\"#21DEFF\" stop-opacity=\".06\"></stop><stop offset=\".73\" stop-color=\"#21DEFF\" stop-opacity=\".23\"></stop><stop offset=\".83\" stop-color=\"#21DEFF\" stop-opacity=\".51\"></stop><stop offset=\".96\" stop-color=\"#21DEFF\" stop-opacity=\".88\"></stop><stop offset=\"1\" stop-color=\"#21DEFF\"></stop>", 6)])], 8, Ce),
			r("linearGradient", {
				id: `${e.uniqueID}u`,
				x1: "16.677",
				y1: "13.17",
				x2: "15.83",
				y2: "9.031",
				gradientUnits: "userSpaceOnUse"
			}, [...t[32] || (t[32] = [i("<stop stop-color=\"#44B044\"></stop><stop offset=\".11\" stop-color=\"#44B044\" stop-opacity=\".8\"></stop><stop offset=\".27\" stop-color=\"#44B044\" stop-opacity=\".52\"></stop><stop offset=\".43\" stop-color=\"#44B044\" stop-opacity=\".29\"></stop><stop offset=\".58\" stop-color=\"#44B044\" stop-opacity=\".13\"></stop><stop offset=\".7\" stop-color=\"#44B044\" stop-opacity=\".03\"></stop><stop offset=\".8\" stop-color=\"#44B044\" stop-opacity=\"0\"></stop>", 7)])], 8, we),
			r("linearGradient", {
				id: `${e.uniqueID}v`,
				x1: "4.819",
				y1: "8.885",
				x2: "22.692",
				y2: "14.803",
				gradientUnits: "userSpaceOnUse"
			}, [...t[33] || (t[33] = [
				r("stop", { "stop-color": "#3066FB" }, null, -1),
				r("stop", {
					offset: ".38",
					"stop-color": "#2F64F7"
				}, null, -1),
				r("stop", {
					offset: ".74",
					"stop-color": "#2857D9"
				}, null, -1),
				r("stop", {
					offset: "1",
					"stop-color": "#3C7EFF"
				}, null, -1)
			])], 8, Te),
			r("linearGradient", {
				id: `${e.uniqueID}I`,
				x1: "16.438",
				y1: "1.578",
				x2: "11.921",
				y2: "12.742",
				gradientUnits: "userSpaceOnUse"
			}, [...t[34] || (t[34] = [i("<stop stop-color=\"#3774FF\"></stop><stop offset=\".05\" stop-color=\"#3774FF\" stop-opacity=\".91\"></stop><stop offset=\".16\" stop-color=\"#3774FF\" stop-opacity=\".66\"></stop><stop offset=\".32\" stop-color=\"#3774FF\" stop-opacity=\".28\"></stop><stop offset=\".43\" stop-color=\"#3774FF\" stop-opacity=\"0\"></stop>", 5)])], 8, Ee)
		])
	], 10, s);
}
var $ = /* @__PURE__ */ n(o, [["render", De]]);
//#endregion
export { $ as default };

//# sourceMappingURL=webex.js.map